<template>
  <div>
    <div class="rules" @click="showModal">活动规则</div>
    <rule-modal ref="ruleModal" :data="rule" />
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import Toast from '@/components/Toast/Toast.vue';
import ruleModal from './RuleModal.vue';
@Component({
  components: {
    Toast,
    ruleModal,
  },
  filters: {
    phoneHide(value: string) {
      if (!value) {
        return value;
      }
      const reg = /(\d{3})(\d*)(\d{4})/;
      return value.replace(
        reg,
        (fullInput: string, g1: string, g2: string, g3: string) => {
          const len = g2.length;

          return g1 + new Array(len + 1).join('*') + g3;
        }
      );
    },
  },
})
export default class PhoneValidate extends Vue {
  @Prop({}) rule!: any;

  showModal() {
    const modal = this.$refs.ruleModal;
    if (modal) {
      modal.toggleModal(true);
    }
  }
}
</script>

<style lang="scss" scoped>
.rules {

  position: absolute;
  top: 65px;
  right: 0;
  z-index: 10;
  width: 135px;
  height: 46px;
  color: #fffdc9;
  font-weight: 600;

  font-size: 24px;
  line-height: 46px;
  text-align: center;
  background-image: linear-gradient(135deg, #4c38cd 0%, #e600e7 100%);
  border-radius: 100px 0px 0px 100px;
  border-radius: 23px 0 0 23px;
  box-shadow: 0 10px 14px -13px #ff00f2;
  filter: blur(0px);
}
</style>
